<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">
            
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mt-2">
                    <div class="col-6">
                        <button type="button" class="btn  btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateActivitymodal" (click)="clearActivity()" *ngIf="fp.activitycreate">Add
                             Activity</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn  btn-sm text-right" (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
                <!-- ejs-grid -->
                <div class="row mt-3" style="min-height: 500px;">
                    <div class="col">
                        <ejs-grid #gridActivityGroup [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
                        [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                        (dataStateChange)='dataChangeActivity($event)' [showColumnChooser]='true'
                        (actionBegin)="onActionActivity($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal"
                                        data-bs-target="#CreateActivitymodal" (click)="getDetails(data)"  
                                        *ngIf="fp.activityupdate"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" data-bs-toggle="modal"
                                        data-bs-target="#deleteActivityModal" (click)="setDeleteId(data.id)"  
                                        *ngIf="fp.activitydelete"><i
                                            class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="activityCode" headerText="ActivityCode" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="activityName" headerText="ActivityName" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
    
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showActivityColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- For Create or Update Modal -->
<span id="openActivityModal" data-bs-toggle="modal" data-bs-target="#CreateActivitymodal"></span>
<div class="modal fade" id="CreateActivitymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                        <span
                     *ngIf="saveactivity.id == '00000000-0000-0000-0000-000000000000'">
                        Create Service Activity</span> 
                    <span *ngIf="saveactivity.id !='00000000-0000-0000-0000-000000000000'">Update Service Group</span> 
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="clearActivity()"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label> ActivityCode<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveactivity.activityCode" />
                    </div>
                </div> 
                <div class="row">
                    <div class="col-lg-5 mt-1">
                        <label> ActivityName<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7 mt-1">
                        <input type="text" class="form-control" [(ngModel)]="saveactivity.activityName" />
                    </div>
                </div> 

                
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateActivity();" 
                 [disabled]="isSaveorUpdateBoolean || (saveactivity.activityCode== ''||saveactivity.activityCode== undefined||
                saveactivity.activityName== ''|| saveactivity.activityName== undefined)">
                 <span
                        *ngIf="saveactivity.id == '00000000-0000-0000-0000-000000000000'"> Save & Close</span>  
                         <span *ngIf="saveactivity.id != '00000000-0000-0000-0000-000000000000'" >Update & Close</span>  
                    </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal" (click)="clearActivity()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeActivityModal" data-bs-target="#deleteActivityModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteActivityModal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteActivity()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearActivity()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>